import StickyBottomBar from "./StickyBottomBar";

export default StickyBottomBar;
export { stickyBottomBarFirstTriggerStyles } from "./StickyBottomBarTrigger/StickyBottomBarTrigger.styles";
export type { StickyBottomBarProps } from "./StickyBottomBar.d";
